import { Notifications } from '@unistocks/features/notifications/notifications';
import { t } from '@unistocks/shared/localization/index.ts';
import Head from 'expo-router/head';

export default function NotificationsScreen() {
  return (
    <>
      <Head>
        <title>{t('::Menu:Notifications')}</title>
      </Head>
      <Notifications />
    </>
  );
}
